import { z } from "zod";
import { siteNow, toUtcIso } from "@/lib/datetime.schedule";

/** Empty or whitespace-only strings become null after trim. */
export function trimToNull(value: string | null | undefined): string | null {
  return value?.trim() ? value.trim() : null;
}

function isHttpOrHttpsUrl(value: string): boolean {
  try {
    const protocol = new URL(value).protocol;
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}

/** Optional HTTP(S) URL, empty string, or nullish → trimmed URL or null. */
export const optionalHttpUrlOrEmpty = z
  .union([
    z.string().url().refine(isHttpOrHttpsUrl, { message: "URL must use http or https" }),
    z.literal(""),
  ])
  .nullish()
  .transform(trimToNull);

export function publishedOnCreate(data: { published?: boolean; published_at?: string }) {
  return {
    published: data.published ?? true,
    published_at: data.published_at ?? toUtcIso(siteNow()),
  };
}

export function publishedOnUpdate(data: { published?: boolean; published_at?: string }) {
  return {
    published: data.published ?? true,
    ...(data.published_at ? { published_at: data.published_at } : {}),
  };
}
